<template>
    <div v-if="props.showModal" class="modal-overlay">
        <div class="modal">
            <h3>Selecionar EP</h3>

            <table class="ep-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ep in lsDados" :key="ep.id">
                        <td>{{ ep.id }}</td>
                        <td>{{ ep.nmep }}</td>
                        <td><button @click="selecionarEp(ep)">Selecionar</button></td>
                    </tr>
                </tbody>
            </table>
            <button class="close-button" @click="closeModal">Fechar</button>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Api } from '@/funcoes/apiExport';

const props = defineProps({showModal: { type: Boolean, required: true }});
const emit = defineEmits(['close', 'epSelecionada']);
const lsDados = ref([]);

async function carregarEps() {
    try {
        const req = await Api.genericGet('/listas/eps');
        lsDados.value = req || [];
    } catch (error) {
        console.error('Erro ao carregar entidades:', error);
    }
}

const selecionarEp = (ep) => {
    emit('epSelecionada', ep);
    closeModal();
}

const closeModal = () => {emit('close');}

onMounted(carregarEps)
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal {
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.ep-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.ep-table th,
.ep-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
}

.ep-table th {
    background: #f4f4f4;
}

.close-button {
    margin-top: 20px;
    background: #f44;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 4px;
}

.close-button:hover {
    background: #d33;
}
</style>
  